export const UPDATE_SEARCHTDATA_TAIKHOANICLOUD = "UPDATE_SEARCHTDATA_TAIKHOANICLOUD";
